/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: nJ1Nn58LcfAm7wemZm71QH
// Component: 3h2MZU5cY1NW
import * as React from "react";
import {
  PlasmicImg as PlasmicImg__,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  hasVariant,
  renderPlasmicSlot,
  useCurrentUser,
  useDollarState
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";
import ButtonActionPictogram from "../../ButtonActionPictogram"; // plasmic-import: hophp8l6gJc0/component
import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: nJ1Nn58LcfAm7wemZm71QH/styleTokensProvider
import "@plasmicapp/react-web/lib/plasmic.css";
import "./plasmic.css"; // plasmic-import: nJ1Nn58LcfAm7wemZm71QH/projectcss
import sty from "./PlasmicOp1WebAw.module.css"; // plasmic-import: 3h2MZU5cY1NW/css
import image9ARcsVGaJAiQd from "./images/image9.svg"; // plasmic-import: ARcsVGaJAiQD/picture
import image79RYuMaKoLyqbN from "./images/image79.svg"; // plasmic-import: rYUMaKOLyqbN/picture
import image6740GeZjck4Ww5 from "./images/image67.svg"; // plasmic-import: 40GeZJCK4WW5/picture
import image74CN86BPoZo1 from "./images/image74.svg"; // plasmic-import: cN8_-6BPoZO1/picture
import image659Gjv2GpUan12 from "./images/image65.svg"; // plasmic-import: 9GJV2GPUan12/picture

createPlasmicElementProxy;

export const PlasmicOp1WebAw__VariantProps = new Array(
  "isActive",
  "isMaximized"
);

export const PlasmicOp1WebAw__ArgProps = new Array(
  "windowIcon",
  "showBackButton",
  "onClickBackButton",
  "onClickCloseButton",
  "windowId",
  "startingWidth",
  "startingHeight",
  "startingX",
  "startingY",
  "showMaximizeButton",
  "onClickMaximizeButton",
  "maximizedWidth",
  "maximizedHeight",
  "headerSlot",
  "bodySlot"
);

const $$ = {};

function PlasmicOp1WebAw__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(
    () =>
      Object.assign(
        {
          windowIcon: {
            src: image9ARcsVGaJAiQd,
            fullWidth: 20,
            fullHeight: 20,
            aspectRatio: undefined
          },
          showBackButton: false,
          showMaximizeButton: false
        },
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  const stateSpecs = React.useMemo(
    () => [
      {
        path: "isActive",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => $props.isActive
      },
      {
        path: "isMaximized",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => $props.isMaximized
      }
    ],

    [$props, $ctx, $refs]
  );
  const currentUser = useCurrentUser?.() || {};
  const $state = useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $q: {},
    $refs
  });
  const styleTokensClassNames = _useStyleTokens();
  return (
    <div
      data-plasmic-name={"shell"}
      data-plasmic-override={overrides.shell}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        "all",
        "root_reset_nJ1Nn58LcfAm7wemZm71QH",
        "plasmic_default_styles",
        "plasmic_mixins",
        styleTokensClassNames,
        sty.shell,
        { [sty.shellisActive]: hasVariant($state, "isActive", "isActive") }
      )}
    >
      <div
        data-plasmic-name={"header"}
        data-plasmic-override={overrides.header}
        className={classNames("all", sty.header, {
          [sty.headerisActive]: hasVariant($state, "isActive", "isActive")
        })}
      >
        <div
          data-plasmic-name={"leftWrapper"}
          data-plasmic-override={overrides.leftWrapper}
          className={classNames("all", sty.leftWrapper)}
        >
          {(() => {
            try {
              return $props.showBackButton;
            } catch (e) {
              if (
                e instanceof TypeError ||
                e?.plasmicType === "PlasmicUndefinedDataError"
              ) {
                return true;
              }
              throw e;
            }
          })() ? (
            <ButtonActionPictogram
              className={classNames(
                "__wab_instance",
                sty.buttonActionPictogram__s2Ht,
                {
                  [sty.buttonActionPictogramisActive__s2HtYehGw]: hasVariant(
                    $state,
                    "isActive",
                    "isActive"
                  )
                }
              )}
              color={
                hasVariant($state, "isActive", "isActive")
                  ? "white"
                  : "transparentBg"
              }
              iconColor={"primary"}
              onClick={async () => {
                const $steps = {};
                $steps["runOnClickBackButton"] = true
                  ? (() => {
                      const actionArgs = {
                        eventRef: $props["onClickBackButton"]
                      };
                      return (({ eventRef, args }) => {
                        return eventRef?.(...(args ?? []));
                      })?.apply(null, [actionArgs]);
                    })()
                  : undefined;
                if (
                  $steps["runOnClickBackButton"] != null &&
                  typeof $steps["runOnClickBackButton"] === "object" &&
                  typeof $steps["runOnClickBackButton"].then === "function"
                ) {
                  $steps["runOnClickBackButton"] =
                    await $steps["runOnClickBackButton"];
                }
              }}
              pictogram={{
                src: image79RYuMaKoLyqbN,
                fullWidth: 20,
                fullHeight: 20,
                aspectRatio: undefined
              }}
              shape={"globalRounding"}
              size={"medium"}
              status={"normal"}
            />
          ) : null}
          <div
            data-plasmic-name={"awIconWrapper"}
            data-plasmic-override={overrides.awIconWrapper}
            className={classNames("all", sty.awIconWrapper)}
          >
            <PlasmicImg__
              data-plasmic-name={"img"}
              data-plasmic-override={overrides.img}
              alt={""}
              className={classNames(sty.img)}
              displayHeight={"auto"}
              displayMaxHeight={"none"}
              displayMaxWidth={"100%"}
              displayMinHeight={"0"}
              displayMinWidth={"0"}
              displayWidth={"auto"}
              loading={"lazy"}
              src={(() => {
                try {
                  return $props.windowIcon;
                } catch (e) {
                  if (
                    e instanceof TypeError ||
                    e?.plasmicType === "PlasmicUndefinedDataError"
                  ) {
                    return {
                      src: image9ARcsVGaJAiQd,
                      fullWidth: 20,
                      fullHeight: 20,
                      aspectRatio: undefined
                    };
                  }
                  throw e;
                }
              })()}
            />
          </div>
        </div>
        <div
          data-plasmic-name={"awHeaderSlotWrapp"}
          data-plasmic-override={overrides.awHeaderSlotWrapp}
          className={classNames("all", sty.awHeaderSlotWrapp)}
        >
          {renderPlasmicSlot({
            defaultContents: null,
            value: args.headerSlot
          })}
        </div>
        <div
          data-plasmic-name={"rightWrapper"}
          data-plasmic-override={overrides.rightWrapper}
          className={classNames("all", sty.rightWrapper)}
        >
          <ButtonActionPictogram
            className={classNames(
              "__wab_instance",
              sty.buttonActionPictogram__lTa0V,
              {
                [sty.buttonActionPictogramisActive__lTa0VYehGw]: hasVariant(
                  $state,
                  "isActive",
                  "isActive"
                ),
                [sty.buttonActionPictogramisMaximized__lTa0VK6O9Q]: hasVariant(
                  $state,
                  "isMaximized",
                  "isMaximized"
                )
              }
            )}
            color={
              hasVariant($state, "isActive", "isActive")
                ? "transparentBg"
                : "transparentBg"
            }
            iconColor={"secondary"}
            onClick={async () => {
              const $steps = {};
              $steps["runOnClickMaximizeButton"] = true
                ? (() => {
                    const actionArgs = {
                      eventRef: $props["onClickMaximizeButton"]
                    };
                    return (({ eventRef, args }) => {
                      return eventRef?.(...(args ?? []));
                    })?.apply(null, [actionArgs]);
                  })()
                : undefined;
              if (
                $steps["runOnClickMaximizeButton"] != null &&
                typeof $steps["runOnClickMaximizeButton"] === "object" &&
                typeof $steps["runOnClickMaximizeButton"].then === "function"
              ) {
                $steps["runOnClickMaximizeButton"] =
                  await $steps["runOnClickMaximizeButton"];
              }
            }}
            pictogram={
              hasVariant($state, "isMaximized", "isMaximized")
                ? {
                    src: image74CN86BPoZo1,
                    fullWidth: 20,
                    fullHeight: 20,
                    aspectRatio: undefined
                  }
                : {
                    src: image6740GeZjck4Ww5,
                    fullWidth: 20,
                    fullHeight: 20,
                    aspectRatio: undefined
                  }
            }
            shape={"globalRounding"}
            size={"medium"}
            status={"normal"}
          />

          <ButtonActionPictogram
            className={classNames(
              "__wab_instance",
              sty.buttonActionPictogram__aza6Y,
              {
                [sty.buttonActionPictogramisActive__aza6YYehGw]: hasVariant(
                  $state,
                  "isActive",
                  "isActive"
                )
              }
            )}
            color={
              hasVariant($state, "isActive", "isActive")
                ? "white"
                : "transparentBg"
            }
            iconColor={"primary"}
            onClick={async () => {
              const $steps = {};
              $steps["runOnClickCloseButton"] = true
                ? (() => {
                    const actionArgs = {
                      eventRef: $props["onClickCloseButton"]
                    };
                    return (({ eventRef, args }) => {
                      return eventRef?.(...(args ?? []));
                    })?.apply(null, [actionArgs]);
                  })()
                : undefined;
              if (
                $steps["runOnClickCloseButton"] != null &&
                typeof $steps["runOnClickCloseButton"] === "object" &&
                typeof $steps["runOnClickCloseButton"].then === "function"
              ) {
                $steps["runOnClickCloseButton"] =
                  await $steps["runOnClickCloseButton"];
              }
            }}
            pictogram={{
              src: image659Gjv2GpUan12,
              fullWidth: 20,
              fullHeight: 20,
              aspectRatio: undefined
            }}
            shape={"globalRounding"}
            size={"medium"}
            status={"normal"}
          />
        </div>
      </div>
      <div
        data-plasmic-name={"awBodySlotWrapp"}
        data-plasmic-override={overrides.awBodySlotWrapp}
        className={classNames("all", sty.awBodySlotWrapp, {
          [sty.awBodySlotWrappisActive]: hasVariant(
            $state,
            "isActive",
            "isActive"
          )
        })}
      >
        {renderPlasmicSlot({
          defaultContents: null,
          value: args.bodySlot
        })}
      </div>
    </div>
  );
}

const PlasmicDescendants = {
  shell: [
    "shell",
    "header",
    "leftWrapper",
    "awIconWrapper",
    "img",
    "awHeaderSlotWrapp",
    "rightWrapper",
    "awBodySlotWrapp"
  ],

  header: [
    "header",
    "leftWrapper",
    "awIconWrapper",
    "img",
    "awHeaderSlotWrapp",
    "rightWrapper"
  ],

  leftWrapper: ["leftWrapper", "awIconWrapper", "img"],
  awIconWrapper: ["awIconWrapper", "img"],
  img: ["img"],
  awHeaderSlotWrapp: ["awHeaderSlotWrapp"],
  rightWrapper: ["rightWrapper"],
  awBodySlotWrapp: ["awBodySlotWrapp"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicOp1WebAw__ArgProps,
          internalVariantPropNames: PlasmicOp1WebAw__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicOp1WebAw__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "shell") {
    func.displayName = "PlasmicOp1WebAw";
  } else {
    func.displayName = `PlasmicOp1WebAw.${nodeName}`;
  }
  return func;
}

export const PlasmicOp1WebAw = Object.assign(
  // Top-level PlasmicOp1WebAw renders the root element
  makeNodeComponent("shell"),
  {
    // Helper components rendering sub-elements
    header: makeNodeComponent("header"),
    leftWrapper: makeNodeComponent("leftWrapper"),
    awIconWrapper: makeNodeComponent("awIconWrapper"),
    img: makeNodeComponent("img"),
    awHeaderSlotWrapp: makeNodeComponent("awHeaderSlotWrapp"),
    rightWrapper: makeNodeComponent("rightWrapper"),
    awBodySlotWrapp: makeNodeComponent("awBodySlotWrapp"),
    // Metadata about props expected for PlasmicOp1WebAw
    internalVariantProps: PlasmicOp1WebAw__VariantProps,
    internalArgProps: PlasmicOp1WebAw__ArgProps
  }
);

export default PlasmicOp1WebAw;
/* prettier-ignore-end */
